import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebsiteRoutingModule } from './website-routing.module';
import { HomeComponent } from './home/home.component';
import { ResultComponent } from './result/result.component';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    HomeComponent,
    ResultComponent
  ],
  imports: [
    CommonModule,
    WebsiteRoutingModule,
    NgxSpinnerModule
  ]
})
export class WebsiteModule { }
